import constants from '@ahmdigital/constants';

import getCodeType from '../get-code-type';

// @ts-expect-error - Automatic, Please fix when editing this file
const getIsReferralCodeType = (offer) => getCodeType(offer) === constants.OFFER_CODE_TYPE.REFERRAL;

export default getIsReferralCodeType;
